import React, { useEffect } from "react";
import { Loading } from "components/form";
import { useGallery } from "store/gallery";
import { Item } from "./";

export default function Gallery(props) {
  const {
    getList,
    loading,
    list,
    dispatch,
    current_page,
    last_page,
    per_page,
  } = useGallery();

  useEffect(() => {
    if (!list) {
      dispatch(getList());
    }
  }, [list, dispatch, getList]);

  const loadMore = () => {
    if (current_page < last_page && !loading) {
      dispatch(getList(undefined, undefined, current_page + 1));
    }
  };

  const handlePageChange = (page) => {
    if (page !== current_page && page <= last_page) {
      dispatch(getList(undefined, undefined, page));
    }
  };

  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 p-6 bg-white rounded-xl shadow-lg overflow-y-auto"
      style={{ maxHeight: "calc(100vh - 200px)" }} // Responsive height
      onClick={() => props.select(null)}
      onScroll={(e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollTop + clientHeight >= scrollHeight - 50) {
          loadMore();
        }
      }}
    >
      {/* List of items */}
      {list && list.length > 0 ? (
        list.map((item, index) => (
          <React.Fragment key={item.id}>
            {/* Display page number divider */}
            {index % per_page === 0 && (
              <div className="col-span-full w-full text-center my-6">
                <div className="w-full inline-block rounded-lg  px-6 py-2 border border-gray-200">
                  <span className="text-sm text-gray-700 font-semibold">
                      صفحه :    {Math.ceil((index + 1) / per_page) } 👇 
                  </span>
                </div>
              </div>
            )}
  
            {/* Item */}
            <div className="w-full rounded-lg  transition-shadow duration-300">
              <Item
                select={props.select}
                item={item}
                selected={props.selectedItem === item}
              />
            </div>
          </React.Fragment>
        ))
      ) : (
        <div className="col-span-full text-center text-gray-500 text-lg py-12">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-12 w-12 mx-auto mb-4 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
          موردی یافت نشد.
        </div>
      )}
  
      {/* Loading spinner */}
      {loading && list && (
        <div className="col-span-full flex justify-center mt-6">
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 border-4 border-violet-600 border-t-transparent rounded-full animate-spin"></div>
            <p className="mt-2 text-gray-600">در حال بارگذاری...</p>
          </div>
        </div>
      )}
  
      {/* Pagination button */}
      {!loading && list && list.length > 0 && current_page < last_page && (
        <div className="col-span-full flex justify-center mt-8">
          <button
            onClick={() => handlePageChange(current_page + 1)}
            className="px-6 py-2 bg-violet-600 text-white rounded-lg hover:bg-violet-700 transition-colors shadow-md text-sm"
          >
            بارگذاری صفحه بعد
          </button>
        </div>
      )}
  
      {/* Pagination controls */}
      <div className="col-span-full flex justify-center mt-6 space-x-6 gap-3">
        {current_page > 1 && (
          <button
            onClick={() => handlePageChange(current_page - 1)}
            className="px-6 py-2 bg-violet-600 text-white rounded-lg hover:bg-violet-700 transition-colors shadow-md text-sm"
          >
            صفحه قبلی
          </button>
        )}
        {current_page < last_page && (
          <button
            onClick={() => handlePageChange(current_page + 1)}
            className="px-6 py-2 bg-violet-600 text-white rounded-lg hover:bg-violet-700 transition-colors shadow-md text-sm"
          >
            صفحه بعد
          </button>
        )}
      </div>
    </div>
  );
}
